export default class Dialog {
    constructor(dialog) {
        this.dialog = dialog;
        this.dialogBody = this.dialog.querySelector('.dialog__body');
        this.cantClose = this.dialog.hasAttribute('data-dialog-cantclose');
        this.triggers = document.querySelectorAll(`[data-dialog-open="${this.dialog.id}"]`);
        this.closeCookie = this.dialog.getAttribute('data-dialog-setclosecookie');
        this.lastFocused;

        if (!this.triggers) return;

        this.init();
    }

    openDialog(root) {
        root.lastFocused = document.activeElement;
        root.dialog.removeAttribute('hidden');
        document.body.style.overflowY = 'hidden';
        root.dialogBody.style.overflowY = 'auto';

        // Mostly reliable fix for iOS issue where VO focus is not moved
        // to the dialog on open. Credit to Thomas Jaggi - codepen.io/backflip
        // for the fix.
        requestAnimationFrame(function () {
            root.dialog.focus();
        });
    }

    closeDialog(root) {
        root.dialog.setAttribute('hidden', 'true');
        document.body.style.overflowY = 'auto';
        
        if (root.lastFocused) {
            root.lastFocused.focus();
            root.lastFocused = null;
        }

        if (root.closeCookie) {
            const parameters = root.closeCookie.split(',');
            const name = parameters[0];
            const value = parameters[1];
            const days = parameters[2];
            const date = new Date;

            date.setTime(date.getTime() + (24*60*60*1000*days));
            document.cookie = `${name}=${value};path=/;expires=${date.toGMTString()}`;
        }
    }

    setupDialog() {
        this.dialog.setAttribute('tabindex', '0');
    }

    setupTriggers() {
        const root = this;

        this.triggers.forEach(trigger => {
            if (trigger.nodeName !== 'BUTTON') {
                trigger.setAttribute('role', 'button');
                trigger.tabIndex = 0;
            }

            trigger.removeAttribute('disabled');
            trigger.removeAttribute('hidden');

            trigger.addEventListener('click', () => root.openDialog(root));
        });
    }

    setupListeners() {
        const root = this;

        root.dialog.addEventListener('click', event => {
            if (event.target.closest('[data-dialog-close]')) {
                root.closeDialog(root);
            } else if (!event.target.closest('.dialog__body')) {
                if (!root.cantClose) root.closeDialog(root);
            }
        });

        root.dialog.addEventListener('keydown', event => {
            if (event.keyCode === 27) {
                root.closeDialog(root);
            }
        });
    }

    init() {
        this.setupDialog();
        this.setupTriggers();
        this.setupListeners();
    }
}